"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = tslib_1.__importStar(require("@antv/util"));
var event_1 = require("../../util/event");
exports.EVENT_MAP = event_1.EVENT_MAP;
exports.onEvent = event_1.onEvent;
var SHAPE_EVENT_MAP = {
    onRectClick: 'polygon:click',
    onRectDblclick: 'polygon:dblclick',
    onRectMousemove: 'polygon:mousemove',
    onRectMouseenter: 'polygon:mouseenter',
    onRectMouseleave: 'polygon:mouseleave',
    onRectMousedown: 'polygon:mousedown',
    onRectMouseup: 'polygon:mouseup',
    onRectContextmenu: 'polygon:contextmenu',
    test: 'breadcrumb:click',
};
_.assign(event_1.EVENT_MAP, SHAPE_EVENT_MAP);
//# sourceMappingURL=event.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/treemap/event.js
// module id = 986
// module chunks = 37